module.exports = __webpack_public_path__ + "static/media/domain.79a2df9c.svg";